module.exports = __webpack_public_path__ + "images/spokesmodel-cbbe529e9310b3d2e89877c798d0dc80.png";